import APIModel from "../APIModel";

export default class Users extends APIModel {
  private readonly resourceUrl: string;

  constructor() {
    super();
    this.resourceUrl = "users";
  }

  /* Get */

  async getOnline(): Promise<any> {
    return await this.http
      .ignoreErrorHandler()
      .get(`${this.resourceUrl}/online`, {});
  }

  async changeData(): Promise<any> {
    return "";
  }

  async profile(userId?: number): Promise<any> {
    return await this.http.get(`users/${userId}/profile`);
  }

  async checkStatus(id: number): Promise<any> {
    return await this.http
      .ignoreGlobalPreloader()
      .ignoreErrorHandler(500)
      .get(`${this.resourceUrl}/${id}/read`, {});
  }

  async getData(params: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500)
      .get(`${this.resourceUrl}`, params);
  }

  async getForEdit(id: string): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/${id}/edit`);
  }

  async getClient(id: string): Promise<any> {
    return await this.http
      .ignoreErrorHandler(404)
      .get(`${this.resourceUrl}/${id}/client`, {});
  }

  async getList(params = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500)
      .get(`${this.resourceUrl}/list`, params);
  }
  async getEmployeesList(params = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500)
      .get(`${this.resourceUrl}/list/employees`, params);
  }

  async getBeneficiariesList(params = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500)
      .get(`${this.resourceUrl}/list/beneficiaries`, params);
  }

  async getSpecialists(params = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500)
      .get(`${this.resourceUrl}/list/specialists`, params);
  }

  async edit(id: string, payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .useFormData()
      .post(`${this.resourceUrl}/${id}?_method=PATCH`, payload);
  }

  async create(payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422, 500)
      .useFormData()
      .post(`${this.resourceUrl}`, payload);
  }

  async update(payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .patch(`${this.resourceUrl}/${payload.id}`, payload);
  }

  async delete(id: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler()
      .delete(`${this.resourceUrl}`, { id });
  }

  async changeUserPassword(id: any, payload: any = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler()
      .patch(`${this.resourceUrl}/${id}/reset_password`, payload);
  }

  async login(endpoint: string, payload: any) {
    return await this.http.post(endpoint, payload);
  }

  async loginAs(id: number) {
    return await this.http.get(`login_as/${id}`);
  }
}
